import {
    Box,
    LinearProgress,
    LinearProgressProps,
    Typography,
} from "@mui/material";

export default function LinearProgressWithLabel(
    props: LinearProgressProps & {
        value: number;
        classes?: {
            rootsx?: object;
            linearProgressSx?: object;
        };
    }
) {
    return (
        <Box
            sx={{
                display: "flex",
                padding: "0.0625rem 0rem;",
                alignItems: "center",
                gap: "0.5rem",
                alignSelf: "stretch",
                width: "50%",
                ...props?.classes?.rootsx,
            }}
        >
            <LinearProgress
                variant="determinate"
                sx={{
                    // width: "141.333px",
                    top: "0.5rem",
                    alignSelf: "stretch",
                    borderRadius: "3.125rem",
                    display: "flex",
                    height: "0.375rem",
                    paddingRight: "0px",
                    alignItems: "center",
                    flex: "1 0 0",
                    //
                    background: "#FFF",

                    ".MuiLinearProgress-bar": {
                        borderRadius: "5.375rem",
                    },
                    ...props?.classes?.linearProgressSx,
                }}
                {...props}
            />
            <Box sx={{ width: 40 }}>
                <Typography
                    variant="body2"
                    sx={{
                        color: "#023",
                        leadingTrim: "both",

                        textEdge: "cap",
                        fontFamily: "Roboto",
                        fontSize: "1rem",
                        fontStyle: "normal",
                        fontWeight: 500,
                        lineHeight: "normal",
                    }}
                >{`${Math.round(props.value)}%`}</Typography>
            </Box>
        </Box>
    );
}
